import { LeadLabel } from "./lead-label";

export function LeadLabels(): React.ReactElement {
  return (
    <>
      <LeadLabel label="I" colIndex={0} rowIndex={0} />
      <LeadLabel label="II" colIndex={0} rowIndex={1} />
      <LeadLabel label="III" colIndex={0} rowIndex={2} />
      <LeadLabel label="aVR" colIndex={1} rowIndex={0} />
      <LeadLabel label="aVL" colIndex={1} rowIndex={1} />
      <LeadLabel label="aVF" colIndex={1} rowIndex={2} />
      <LeadLabel label="V1" colIndex={2} rowIndex={0} />
      <LeadLabel label="V2" colIndex={2} rowIndex={1} />
      <LeadLabel label="V3" colIndex={2} rowIndex={2} />
      <LeadLabel label="V4" colIndex={3} rowIndex={0} />
      <LeadLabel label="V5" colIndex={3} rowIndex={1} />
      <LeadLabel label="V6" colIndex={3} rowIndex={2} />
    </>
  );
}
